module.exports = __webpack_public_path__ + "img/p24.1dab2850.png";